import React from "react";
import { Controller } from "react-hook-form";

const InputField = ({ name, label, control, rules }) => (
  <div style={{ display: "flex", flexDirection: "column", marginBottom: "12px" }}>
    <label>
      {label}
      {rules?.required && <span style={{ color: "red" }}> *</span>}
    </label>
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <>
          <input {...field} style={error ? { borderColor: "red" } : {}} />
          {error && <span style={{ color: "red", fontSize: "12px" }}>{error.message || "This field is required"}</span>}
        </>
      )}
    />
  </div>
);

export default InputField;
